export const properties = [
   // GET/SET
   'volume', 'src', 'currentTime', 'muted',

   // GET only
   'duration', 'paused', 'ended', 'levels', 'currentLevel',

   // SET only
   'level',

   // OTHERS
   'error', 'currentSrc', 'networkState', 'preload', 'buffered', 'bufferedBytes', 'bufferedTime',
   'readyState', 'seeking', 'initialTime', 'startOffsetTime', 'defaultPlaybackRate', 'playbackRate',
   'played', 'seekable', 'autoplay', 'loop', 'controls'
];

export const methods = [
   'load', 'play', 'pause', 'canPlayType'
];
